<script setup lang="ts">
import { computed } from 'vue';
import type { Emits, Props } from './types';
import ControlLabel from '../controlLabel/controlLabel.vue';

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const localValue = computed({
	get() {
		return props.modelValue;
	},
	set(value) {
		emit('update:modelValue', value);
	},
});

</script>

<template>
	<label
		:class="{
			['top-forms-optionWrapper']: true,
			['top-radio']: true,
			['top-radio_' + name]: name !== '',
			['top-disabled']: disabled,
			['top-error']: isError && !disabled,
		}"
	>
		<input
			v-top-focus.onupdate="isError"
			type="radio"
			:class="{
				['top-forms-focusable']: !disabled,
				['top-forms-option']: true,
				['top-radio_input']: true,
				['top-error']: isError && !disabled,
			}"
			v-model="localValue"
			:name="name"
			:value="value"
			:disabled="disabled"
		>

		<ControlLabel
			v-if="$slots.default"
			:description="description"
			:disabled="disabled"
		>
			<!-- @slot Слот с заголовком -->
			<slot></slot>
		</ControlLabel>
	</label>
</template>

<style>
:root {
	--top-radio-background-color: var(--color-layout-front-1);
	--top-radio-background-color-hover: var(--top-radio-background-color);
	--top-radio-background-color-active: var(--top-radio-background-color);
}

.top-radio {
	cursor: pointer;
}

.top-radio_input {
	border-radius: 50%;
	background: var(--color-layout-front-1);
	border: 1px solid var(--top-forms-border-color);
	width: calc(var(--top-forms-option-height) - 3px * 2);
	height: calc(var(--top-forms-option-height) - 3px * 2);
}

.top-radio_input:hover {
	border-color: var(--top-forms-border-color-hover);
	background: var(--color-layer-primary-1);
}

.top-radio_input:checked {
	border-color: var(--top-forms-option-color);
	border-width: 5px;
}

.top-radio_input:checked:hover {
	border-color: var(--color-bg-primary-2);
}

/* isError */
.top-radio_input.top-error {
	border-color: var(--color-bg-negative-1);
}

.top-radio_input.top-error:hover {
	border-color: var(--color-bg-negative-1);
}
</style>
